import { render, staticRenderFns } from "./TableSizeSelect.vue?vue&type=template&id=f5da2f48&"
import script from "./TableSizeSelect.vue?vue&type=script&lang=ts&"
export * from "./TableSizeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TableSizeSelect.vue?vue&type=style&index=0&id=f5da2f48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports